(function (root) {
  const keys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content'];
  const lifetime = 86400000;
  function publicPath(value) {
    if (typeof value !== 'string' || value.length > 300) return '';
    if (value === '/') return value;
    return /^\/(?:pages|products|collections|blogs|policies)\/[a-z0-9]+(?:[a-z0-9\/-]*[a-z0-9])?$/.test(value) || value === '/search' ? value : '';
  }
  function campaign(search, path, now = Date.now()) {
    const params = new URLSearchParams(search);
    const data = { version: 1, at: now, landingPath: publicPath(path) };
    for (const key of keys) {
      const value = params.get(key);
      if (value && /^[a-z0-9][a-z0-9_-]{0,79}$/i.test(value)) data[key] = value.toLowerCase();
    }
    return data.landingPath && keys.some(key => data[key]) ? data : null;
  }
  function record(value, now = Date.now()) {
    if (!value || value.version !== 1 || !Number.isFinite(value.at) || value.at > now || now - value.at > lifetime) return null;
    const path = publicPath(value.landingPath);
    if (!path) return null;
    const result = { version: 1, at: value.at, landingPath: path };
    for (const key of keys) if (typeof value[key] === 'string' && /^[a-z0-9][a-z0-9_-]{0,79}$/.test(value[key])) result[key] = value[key];
    return keys.some(key => result[key]) ? result : null;
  }
  root.ILSAttributionCore = { keys, publicPath, campaign, record };
})(typeof window === 'undefined' ? globalThis : window);
